import React from 'react';
import 'es6-promise/auto';

import 'mapbox-gl/dist/mapbox-gl.css';
import 'material-design-lite/dist/material.grey-indigo.min.css';

import './index.css';
import Map from './Map.js';
import About from './About.js';
import Timeline from './Timeline';

export default class App extends React.Component {
  constructor(props) {
    super(props)
    this.state = {map: {}}
    this.setMap = this.setMap.bind(this)
    this.toggleAbout = this.toggleAbout.bind(this)
  }
  setMap(map) {
    this.setState({map: map});
  }
  //Toggle about page & map controls
  toggleAbout() {
    const aboutContainer = document.getElementById('layout-about-container');
    const controlContainer = document.getElementsByClassName(
      'mapboxgl-control-container'
    )[0];

    if (aboutContainer.classList.contains('toggled')) {
      aboutContainer.classList.remove('toggled');
      if (controlContainer !== undefined) {
        controlContainer.classList.remove('toggled');
      }
    } else {
      aboutContainer.classList.add('toggled');
      if (controlContainer !== undefined) {
        controlContainer.classList.add('toggled');
      }
    }
  }
  render() {
    return (
      <div className="content">
        <Map map={this.state.map} onMapCreated={this.setMap} />
        <About toggleAbout={this.toggleAbout} />
        <Timeline map={this.state.map}/>
      </div>
    );
  }
}
